import { z } from 'zod';

import { transformKeysToCamelCase } from 'utils/formatters/transform-snake-to-camel';

export const ReferralHistoryResponseSchema = z
  .object({
    data: z.array(
      z.object({
        user_id: z.number(),
        referral_id: z.number(),
        link_name: z.string(),
        ref_code: z.string(),
        date_timestamp: z.number(),
        coin: z.string(),
        referral_reward: z.string(),
        purchase_amount: z.number(),
      }),
    ),
  })
  .transform(transformKeysToCamelCase)
  .transform((data) => ({
    ...data,
    data: data.data.map((data) => ({ ...data, referralReward: Number(data.referralReward) })),
  }));

export type TReferralHistoryResponse = z.infer<typeof ReferralHistoryResponseSchema>;
export type TReferralHistoryData = z.infer<typeof ReferralHistoryResponseSchema>['data'];
